import { render, staticRenderFns } from "./xj_dialog.vue?vue&type=template&id=e10d4eb2&scoped=true"
import script from "./xj_dialog.vue?vue&type=script&lang=js"
export * from "./xj_dialog.vue?vue&type=script&lang=js"
import style0 from "./xj_dialog.vue?vue&type=style&index=0&id=e10d4eb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10d4eb2",
  null
  
)

export default component.exports